/**
 * Annimation du menu des filtres produits
 */
export function initFilterProducts(){

  const target = document.querySelector(".target");
  const links = document.querySelectorAll(".post-type-archive-product__categories a");

  function mouseenterFunc() {
    if (!this.parentNode.classList.contains("active")) {
      for (let i = 0; i < links.length; i++) {
        if (links[i].parentNode.classList.contains("active")) {
          links[i].parentNode.classList.remove("active");
        }
        links[i].style.opacity = "0.25";
      }

      this.parentNode.classList.add("active");
      this.style.opacity = "1";

      const width = this.getBoundingClientRect().width;
      const height = this.getBoundingClientRect().height;
      const left = this.getBoundingClientRect().left + window.pageXOffset;
      const top = this.getBoundingClientRect().top + window.pageYOffset;

      target.style.width = `${width}px`;
      target.style.height = `${height}px`;
      target.style.left = `${left}px`;
      target.style.top = `${top}px`;
      target.style.transform = "none";
    }
  }

  function initFunc(el) {
    if (el.parentNode.classList.contains("active")) {
      const width = el.parentNode.getBoundingClientRect().width;
      const height = el.parentNode.getBoundingClientRect().height;
      const left = el.parentNode.getBoundingClientRect().left + window.pageXOffset;
      const top = el.parentNode.getBoundingClientRect().top + window.pageYOffset;

      target.style.width = `${width}px`;
      target.style.height = `${height}px`;
      target.style.left = `${left}px`;
      target.style.top = `${top}px`;
      target.style.transform = "none";
    }else{
      el.style.opacity = "0.25";
    } 
  }

  for (let i = 0; i < links.length; i++) {
    links[i].addEventListener("mouseenter", mouseenterFunc);
    initFunc(links[i]);
  }

  function resizeFunc() {
    const active = document.querySelector(".post-type-archive-product__categories li.active");

    if (active) {
      const left = active.getBoundingClientRect().left + window.pageXOffset;
      const top = active.getBoundingClientRect().top + window.pageYOffset;

      target.style.left = `${left}px`;
      target.style.top = `${top}px`;
    }
  }

  window.addEventListener("resize", resizeFunc);
}